import React from 'react'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ReactComponent as PencilIcon } from '../../../../../assets/icons/pencil.svg'

import useStyles from '../../../../../styles/common/drawerForms'

const SkeletonMultipleSectionsForm = ({
  // avoid using more than 10 section, because it can lead to low performance
  skeletonSectionsNumber = 3,
  withEditIcon
}) => {
  const classes = useStyles()

  const sectionTemplate = (
    <section className={classes.section}>
      <h3 className={classnames(classes.sectionTitle, classes.previewSectionTitle)}>
        <Skeleton width={166} />
      </h3>
      <div className={classes.sectionPreview}>
        <p>
          <Skeleton width={130} />
        </p>
      </div>
      {withEditIcon && <PencilIcon className={classes.sectionIcon} />}
    </section>
  )

  return (
    <>
      {Array(skeletonSectionsNumber)
        .fill(Math.random())
        .map((i, index) => (
          <div key={index}>{sectionTemplate}</div>
        ))}
    </>
  )
}

SkeletonMultipleSectionsForm.propTypes = {
  withEditIcon: PropTypes.bool
}

export default SkeletonMultipleSectionsForm
